module.exports = __webpack_public_path__ + "static/media/dutch_bucket_for_cherry_tomato_blog.d23895f9.webp";